export default "__VITE_ASSET__DNqRhAK5__"